import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import Card from '../../../../../../shared/components/Card';
import {
  CardLabel,
  CardValue,
  LabelAndValueContainer,
} from '../../../../../../shared/components/Card/components/CardComponents';
import theme from '../../../../../../styles/theme';
import checkValue from '../../../../../../utils/values';
import BarChart from '../components/CardWithBarChart/components/BarChart';
import Frame from './components/Frame';

export default function CriptoDashboard() {
  const criptoFaresState = useSelector(
    (reducer: IReducer) => reducer.criptoFares
  );
  return (
    <Frame.Base isActive={criptoFaresState.isActive}>
      <Card
        isActive
        title="Recebidas por clientes"
        display="flex"
        flexDirection="column"
        gridArea="tarifasRecebidasClientes"
        padding=""
        justifyContent="flex-start"
        width="100%"
        height="100%"
        maxWidth="300px"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Quantidade</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {criptoFaresState.criptoReceived.quantity}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Valor</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(criptoFaresState.criptoReceived.value).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive
        title={
          criptoFaresState.partner
            ? 'Tarifas repassadas'
            : 'Recebidas por White Label'
        }
        display="flex"
        flexDirection="column"
        padding=""
        gridArea="tarifasRecebidas"
        maxWidth="300px"
        justifyContent="start"
        width="100%"
        height="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Quantidade</CardLabel>
          <CardValue
            color={
              !criptoFaresState.partner
                ? theme.colors.emphasis
                : theme.colors.red
            }>
            {criptoFaresState.criptoSent.quantity}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Valor</CardLabel>
          <CardValue
            color={
              !criptoFaresState.partner
                ? theme.colors.emphasis
                : theme.colors.red
            }>
            {checkValue(criptoFaresState.criptoSent.value).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive
        title="Criptos Movimentadas nos Últimos 12 Meses"
        gridArea="lastTwelveMonths"
        display="flex"
        flexDirection="column"
        justifyContent="start"
        width="100%"
        height="100%"
        minHeight="286px"
        backgroundColor="#FFFFFF">
        <BarChart
          data={criptoFaresState.lastTwelveMonths}
          hasOneData={false}
          firstValueColor={theme.colors.emphasis}
          secondValueColor={theme.colors.red}
          labelForTwoDatas={{
            firstLabel: `Recebidas WL`,
            secondLabel: 'Recebidas Cliente',
          }}
        />
      </Card>
    </Frame.Base>
  );
}
